/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTenantIntegrationChannels } from 'app/entities/tenant-integration-channel/tenant-integration-channel.reducer';
import { getEntities as getTenantIntegrationTemplates } from 'app/entities/tenant-integration-template/tenant-integration-template.reducer';
import { OperationType } from 'app/shared/model/enumerations/operation-type.model';
import { createEntity, getEntity, reset, updateEntity } from './communication-log.reducer';

export const CommunicationLogUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tenantIntegrationChannels = useAppSelector(state => state.tenantIntegrationChannel.entities);
  const tenantIntegrationTemplates = useAppSelector(state => state.tenantIntegrationTemplate.entities);
  const communicationLogEntity = useAppSelector(state => state.communicationLog.entity);
  const loading = useAppSelector(state => state.communicationLog.loading);
  const updating = useAppSelector(state => state.communicationLog.updating);
  const updateSuccess = useAppSelector(state => state.communicationLog.updateSuccess);
  const operationTypeValues = Object.keys(OperationType);

  const handleClose = () => {
    navigate(`/communication-log${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTenantIntegrationChannels({}));
    dispatch(getTenantIntegrationTemplates({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.noOfRetries !== undefined && typeof values.noOfRetries !== 'number') {
      values.noOfRetries = Number(values.noOfRetries);
    }
    if (values.requestStartTime !== undefined && typeof values.requestStartTime !== 'number') {
      values.requestStartTime = Number(values.requestStartTime);
    }
    if (values.responseStartTime !== undefined && typeof values.responseStartTime !== 'number') {
      values.responseStartTime = Number(values.responseStartTime);
    }
    if (values.responseCode !== undefined && typeof values.responseCode !== 'number') {
      values.responseCode = Number(values.responseCode);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...communicationLogEntity,
      ...values,
      channel: tenantIntegrationChannels.find(it => it.id.toString() === values.channel?.toString()),
      template: tenantIntegrationTemplates.find(it => it.id.toString() === values.template?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          operationType: 'POST',
          ...communicationLogEntity,
          channel: communicationLogEntity?.channel?.id,
          template: communicationLogEntity?.template?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.communicationLog.home.createOrEditLabel" data-cy="CommunicationLogCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.communicationLog.home.createOrEditLabel">Create or edit a CommunicationLog</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="communication-log-id"
                  label={translate('tinyMedicRestApp.communicationLog.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.recepient')}
                id="communication-log-recepient"
                name="recepient"
                data-cy="recepient"
                type="text"
              />
              <UncontrolledTooltip target="recepientLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.recepient" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.status')}
                id="communication-log-status"
                name="status"
                data-cy="status"
                type="text"
              />
              <UncontrolledTooltip target="statusLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.status" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.noOfRetries')}
                id="communication-log-noOfRetries"
                name="noOfRetries"
                data-cy="noOfRetries"
                type="text"
              />
              <UncontrolledTooltip target="noOfRetriesLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.noOfRetries" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.requestURI')}
                id="communication-log-requestURI"
                name="requestURI"
                data-cy="requestURI"
                type="text"
              />
              <UncontrolledTooltip target="requestURILabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.requestURI" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.requestMsg')}
                id="communication-log-requestMsg"
                name="requestMsg"
                data-cy="requestMsg"
                type="text"
              />
              <UncontrolledTooltip target="requestMsgLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.requestMsg" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.requestStartTime')}
                id="communication-log-requestStartTime"
                name="requestStartTime"
                data-cy="requestStartTime"
                type="text"
              />
              <UncontrolledTooltip target="requestStartTimeLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.requestStartTime" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.responseStartTime')}
                id="communication-log-responseStartTime"
                name="responseStartTime"
                data-cy="responseStartTime"
                type="text"
              />
              <UncontrolledTooltip target="responseStartTimeLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.responseStartTime" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.responseCode')}
                id="communication-log-responseCode"
                name="responseCode"
                data-cy="responseCode"
                type="text"
              />
              <UncontrolledTooltip target="responseCodeLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.responseCode" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.responseMsg')}
                id="communication-log-responseMsg"
                name="responseMsg"
                data-cy="responseMsg"
                type="text"
              />
              <UncontrolledTooltip target="responseMsgLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.responseMsg" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.active')}
                id="communication-log-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.cursor')}
                id="communication-log-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.lastUpdated')}
                id="communication-log-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.microSec')}
                id="communication-log-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.timestampEntry')}
                id="communication-log-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.eventName')}
                id="communication-log-eventName"
                name="eventName"
                data-cy="eventName"
                type="text"
              />
              <UncontrolledTooltip target="eventNameLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.eventName" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.operationType')}
                id="communication-log-operationType"
                name="operationType"
                data-cy="operationType"
                type="select"
              >
                {operationTypeValues.map(operationType => (
                  <option value={operationType} key={operationType}>
                    {translate(`tinyMedicRestApp.OperationType.${operationType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="operationTypeLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.operationType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.communicationLog.tenantId')}
                id="communication-log-tenantId"
                name="tenantId"
                data-cy="tenantId"
                type="text"
              />
              <UncontrolledTooltip target="tenantIdLabel">
                <Translate contentKey="tinyMedicRestApp.communicationLog.help.tenantId" />
              </UncontrolledTooltip>
              <ValidatedField
                id="communication-log-channel"
                name="channel"
                data-cy="channel"
                label={translate('tinyMedicRestApp.communicationLog.channel')}
                type="select"
              >
                <option value="" key="0" />
                {tenantIntegrationChannels
                  ? tenantIntegrationChannels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="communication-log-template"
                name="template"
                data-cy="template"
                label={translate('tinyMedicRestApp.communicationLog.template')}
                type="select"
              >
                <option value="" key="0" />
                {tenantIntegrationTemplates
                  ? tenantIntegrationTemplates.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/communication-log" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CommunicationLogUpdate;
